import * as React from 'react'

import { LoanStep } from 'even-ts-static'

import IncentivesDisclaimer from 'embed/components/IncentivesDisclaimer'
import IncentivesHeader from 'embed/components/IncentivesHeader'

import LoanApplicationContainer from './Application/container'
import { CreateAccount } from './CreateAccount'
import { LoanPreviewContainer } from './Preview/container'
import { LoanResultsContainer } from './Results/container'
import SelectedOffer from './SelectedOffer/container'

interface Props {
  selectedStep: LoanStep
  incentivesEnabled: boolean
  isResultsStep: boolean
  isResultsStepWithLoanOffers: boolean
}

const LoanBody: React.FC<Props> = ({ selectedStep }) => {
  switch (selectedStep) {
    case LoanStep.Application:
      return (
        <React.Fragment>
          <SelectedOffer />
          <LoanApplicationContainer />
        </React.Fragment>
      )
    case LoanStep.CreateAccount:
      return <CreateAccount />
    case LoanStep.Results:
      return <LoanResultsContainer />
    default:
      return <LoanPreviewContainer />
  }
}

const Loan: React.FunctionComponent<Props> = (props) => {
  const { incentivesEnabled, isResultsStep, isResultsStepWithLoanOffers } = props

  const showIncentives = incentivesEnabled && (!isResultsStep || isResultsStepWithLoanOffers)

  return (
    <React.Fragment>
      {showIncentives && <IncentivesHeader />}
      <LoanBody {...props} />
      {showIncentives && <IncentivesDisclaimer />}
    </React.Fragment>
  )
}

export default Loan
